import { css } from 'emotion';

export const root = css`
  & video {
    border-radius: 6px;
    background-color: black;
  }
`;

export const videoContainer = css`
  position: relative;
  height: 100%;

  transition: all 0.3s;

  & video {
    transform: scale(-1, 1);
  }
`;

export const screenContainer = css`
  position: relative;
  height: 100%;
  margin-top: 10px;
  transition: all 0.3s;
`;

export const mediaFullScreen = isMobile => (isMobile
  ? css`
        position: fixed !important;
        right: 0;
        top: 0;
        margin-top: 0px;
        z-index: 100;
        left: 0;
        ::after {
          content: '';
          display: block;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.75);
          z-index: -1;
        }
        & video {
          width: 100vw !important;
          right: 0;
          top: 0;
          height: 100%;
          position: relative;
          max-height: unset !important;
        }
      `
  : css`
        position: fixed !important;
        width: 80vw;
        right: 10vw;
        height: 80vh;
        top: 10vh;
        z-index: 100;
        & video {
          max-height: 80vh !important;
        }
      `);

export const fullScreenButton = css`
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 2;
  height: 32px;
  width: 32px;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 6px;
  background: linear-gradient(
    to top right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.2) 41%,
    rgba(0, 0, 0, 0.51) 75%,
    #000000
  );
`;

export const profilePictureContainer = isMobile => css`
  height: 100%;
  width: 100%;
  border-radius: 6px;
  background-color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  ${isMobile
    ? `
    min-height: 250px;
    min-width: 150px;
    `
    : `
    min-height: 183px;
    min-width: 240px;
  `}
`;

export const profilePicture = css`
  height: 60px;
  width: 60px;
  border-radius: 30px;
`;

export const userName = css`
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 2;
  color: white;
  font-size: 16px;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 8px 2px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.2) 41%,
    rgba(0, 0, 0, 0.51) 75%,
    #000000
  );
`;
